import api from './api';

const AuthService = {
    login: (email, password) => api.post('/auth/login', { email, password }).then(r => r.data),
    register: (payload) => api.post('/auth/register', payload).then(r => r.data),
    me: () => api.get('/auth/me').then(r => r.data),
    setLanguage: (language) => api.put('/auth/me/language', { language }).then(r => r.data),
    changePassword: (currentPassword, newPassword) => api.put('/auth/me/password', { currentPassword, newPassword }).then(r => r.data),
    /** Re-checks the password; returns { token } that reveals the prices of one job or quote (`scope`, e.g. "job:12"). */
    unlockMoney: (password, scope) => api.post('/auth/money-unlock', { password, scope }).then(r => r.data),
    twoFactorSetup: () => api.post('/auth/2fa/setup').then(r => r.data),
    twoFactorEnable: (code) => api.post('/auth/2fa/enable', { code }).then(r => r.data),
    twoFactorDisable: (code) => api.post('/auth/2fa/disable', { code }).then(r => r.data),
    twoFactorVerify: (challenge, code) => api.post('/auth/2fa/verify', { challenge, code }).then(r => r.data),
    // Passkeys (Face ID / Touch ID / fingerprint): start → browser ceremony → finish.
    passkeyLoginStart: () => api.post('/auth/passkeys/login/start').then(r => r.data),
    passkeyLoginFinish: (requestId, credential) => api.post('/auth/passkeys/login/finish', { requestId, credential }).then(r => r.data),
    passkeys: () => api.get('/auth/passkeys').then(r => r.data),
    passkeyRegisterStart: () => api.post('/auth/passkeys/register/start').then(r => r.data),
    passkeyRegisterFinish: (requestId, credential, name) => api.post('/auth/passkeys/register/finish', { requestId, credential, name }).then(r => r.data),
    deletePasskey: (id) => api.delete(`/auth/passkeys/${id}`),
};

export default AuthService;
